import gql from 'graphql-tag';

export const addItemToOrderMutation = gql`
  mutation addItemToOrder($input: AddItemToOrderInput!) {
    addItemToOrder(input: $input) {
      Status
      Qty
      Cases
      Bottles
      OrderDet {
        Code
        Qty
        Mobo
        MoboQty {
          OrderNo
          Qty
        }
      }
    }
  }
`;
